/**
 * Card 54406 (2026-10-15, X DM31803) — after purchase, a Doctor Now order never presents the
 * internal default dosage as the customer's prescribed dose.
 *
 * A Doctor Now clinician decides the dose after reviewing the medical history. Oval stores no
 * clinician-prescribed dose (the request's REQ-05 discovery found none), so the dosage a Doctor
 * Now order carries is the internal default that priced it — not a prescription. The order
 * confirmation page and the refill modal therefore show CLINICIAN_DOSAGE_LABEL in its place.
 * DrCare keeps its amount. Presentation only: every stored dose, price and admin view is unchanged.
 *
 * ⚠️ `api/` CANNOT import this file, so `api/services/external/emailService.js` carries a
 * hand-kept COPY of the label for the receipts. tests/unit/doctorNowCustomerDosageSummary.test.js
 * pins the two equal — ⛔ do not reword one copy in isolation.
 *
 * ROLLBACK: revert card 54406's merge commit.
 */
const CLINICIAN_DOSAGE_LABEL = 'Determined by your clinician';

/** The dosage text a customer sees: the clinician label for Doctor Now, the stored amount otherwise. */
const customerDosageText = ({ isDoctorNow, amount }) => (isDoctorNow ? CLINICIAN_DOSAGE_LABEL : amount);

export { CLINICIAN_DOSAGE_LABEL, customerDosageText };
